document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
window.jsLoadStatus = new Map();
window.cssLoadStatus = new Map();
window.theme = window.theme || {};
window.theme = {
  ...window.theme,
  strings:{
    noStock: "Out of stock",
    noMore: "There are no more data!",
    clickRetry: "Click Retry",
    shippingCalculator: {
      singleRate: "There is one shipping rate for this destination:",
      multipleRates: "There are multiple shipping rates for this destination:",
      noRates: "We do not ship to this destination."
    }
  },
  settings: {
    moneyWithCurrencyFormat: null,
    cartType: "sidebar",
    afterAddToCart: "sidebar",
    quickbuyStyle: null,
    animations:true,
    animationsMob:false,
  },
  static: {
    plyrJs:"//www.3comusa.com/cdn/shop/t/38/assets/plyr.js?v=153750561068857331641789071214",
    plyrCss:"//www.3comusa.com/cdn/shop/t/38/assets/plyr.css?v=122745719196851539181789071213",
    hls:"//www.3comusa.com/cdn/shop/t/38/assets/hls.js?v=103281149371848790691789071176",
    swiperJs:"//www.3comusa.com/cdn/shop/t/38/assets/swiper.js?v=179361686571343808231789071233",
    swiperCss:"//www.3comusa.com/cdn/shop/t/38/assets/swiper.css?v=34996922292858527001789071232",
    aosCss:"//www.3comusa.com/cdn/shop/t/38/assets/aos.css?v=171440860698160758581789071075",
    aosJs:"//www.3comusa.com/cdn/shop/t/38/assets/aos.js?v=90494958484447784991789071076",
    niceSelect2Css:"//www.3comusa.com/cdn/shop/t/38/assets/nice-select2.css?v=119250737275302342911789071194",
    niceSelect2Js:"//www.3comusa.com/cdn/shop/t/38/assets/nice-select2.js?v=170325880069290996331789071195",
    translateJs:"//www.3comusa.com/cdn/shop/t/38/assets/translate.js?v=148427421687367473161789071239",
    driverCss:"//www.3comusa.com/cdn/shop/t/38/assets/driver.css?v=66464337345264709341789071096",
    driverJs:"//www.3comusa.com/cdn/shop/t/38/assets/driver.js?v=9527168168962712331789071096",
    googleTransJs:"https://translate.google.com/translate_a/element.js"
  }
};
/**
 * simple modal class for bs modal
 */
class SimpleModal {
  constructor(options = {}) {
    this.options = { backdrop: true, keyboard: true, ...options };
  }

  static show(el) {
    if (!el) return;

    this.addBackdrop();
    el.style.display = "block";

    setTimeout(() => {
      el.classList.add("show");
      this.getBackdrop().classList.add("show");
    }, 10);

    document.body.classList.add("modal-open");
    this.bindEvents(el);
  }

  static hide(el) {
    if (!el) return;

    el.classList.remove("show");
    this.getBackdrop().classList.remove("show");

    setTimeout(() => {
      el.style.display = "none";
      this.removeBackdrop();
      document.body.classList.remove("modal-open");
      this.unbindEvents(el);

      const event = new Event('hidden.bs.modal', { bubbles: true });
      el.dispatchEvent(event);
    }, 300);
  }

  static addBackdrop() {
    if (!document.querySelector(".modal-backdrop")) {
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade";
      document.body.appendChild(backdrop);
    }
  }

  static getBackdrop() {
    return document.querySelector(".modal-backdrop");
  }

  static removeBackdrop() {
    const backdrop = this.getBackdrop();
    if (backdrop) {
      backdrop.remove();
    }
  }

  static bindEvents(el) {
    const closeButtons = el.querySelectorAll('[data-bs-dismiss="modal"], [data-dismiss="modal"]');

    closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.hide(el));
    });

    if (el.dataset.backdrop !== "static") {
      el.addEventListener("click", (e) => {
        if (e.target === el) {
          this.hide(el);
        }
      });
    }

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        this.hide(el);
        document.removeEventListener("keydown", handleEscape);
      }
    };

    document.addEventListener("keydown", handleEscape);
    el.escapeHandler = handleEscape;
  }

  static unbindEvents(el) {
    if (el.escapeHandler) {
      document.removeEventListener("keydown", el.escapeHandler);
      delete el.escapeHandler;
    }
  }
}
/**
 * simple offcanvas class for bs offcanvas
 */
class SimpleOffcanvas {
  constructor(options = {}) {
    this.options = { backdrop: true, keyboard: true, ...options };
  }

  static show(el, backdrop = true) {
    if (!el) return;

    document.body.classList.add("overflow-hidden");
    el.style.visibility = "visible";

    setTimeout(() => {
      el.classList.add("show");
    }, 10);

    if(backdrop) this.addBackdrop();

    this.bindEvents(el);
  }

  static hide(el, backdrop = true) {
    if (!el) return;

    el.classList.remove("show");

    setTimeout(() => {
      el.style.visibility = "hidden";
      document.body.classList.remove("overflow-hidden");
      if(backdrop) this.removeBackdrop();

      this.unbindEvents(el);
    }, 300);
  }

  static toggle(el, backdrop = true) {
    if (el.classList.contains("show")) {
      this.hide(el, backdrop);
    } else {
      this.show(el, backdrop);
    }
  }

  static addBackdrop() {
    if (!document.querySelector(".offcanvas-backdrop")) {
      const backdrop = document.createElement("div");
      backdrop.className = "offcanvas-backdrop fade";
      document.body.appendChild(backdrop);

      setTimeout(() => {
        backdrop.classList.add("show");
      }, 10);
    }
  }

  static removeBackdrop() {
    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (backdrop) {
      backdrop.classList.remove("show");

      setTimeout(() => {
        backdrop.remove();
      }, 300);
    }
  }

  static bindEvents(el) {
    const closeButtons = el.querySelectorAll('[data-bs-dismiss="offcanvas"]');
    closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.hide(el));
    });

    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (backdrop) {
      backdrop.addEventListener("click", () => this.hide(el));
    }

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        this.hide(el);
        document.removeEventListener("keydown", handleEscape);
      }
    };

    document.addEventListener("keydown", handleEscape);
    el.escapeHandler = handleEscape;
  }

  static unbindEvents(el) {
    if (el.escapeHandler) {
      document.removeEventListener("keydown", el.escapeHandler);
      delete el.escapeHandler;
    }
  }
}
/**
 * simple carousel class for bs carousel
 */
class SimpleCarousel {
  constructor(selector) {
    this.el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!this.el) return;
    this.isFade = this.el.classList.contains('carousel-fade');
    this.items = Array.from(this.el.querySelectorAll('.carousel-item'));
    if (this.items.length === 0) return;

    this.currentIndex = this.getActiveIndex();
    this.isSliding = false;
    this.interval = this.getInterval();
    this.timer = null;
    this.isPaused = false;
    this.wasCycling = false;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    this.prevBtn = this.el.querySelector('.carousel-control-prev');
    this.nextBtn = this.el.querySelector('.carousel-control-next');
    this.indicators = Array.from(this.el.querySelectorAll('.carousel-indicators [data-bs-slide-to]'));

    this.bindEvents();
    this.updateIndicators();

    if (this.el.getAttribute('data-bs-ride') === 'carousel') this.cycle();

    this.el.addEventListener('simplecarousel:toSlide', (e) => {
      const i = e.detail?.index;
      if (typeof i === 'number') this.to(i);
    });
  }

  getInterval() {
    const v = this.el.getAttribute('data-bs-interval');
    if (v === 'false' || !v) return null;
    const n = parseInt(v, 10);
    return isNaN(n) ? 5000 : n;
  }

  cycle() {
    this.pause();
    if (!this.interval) return;
    this.isPaused = false;
    this.wasCycling = true;
    this.timer = setInterval(() => {
      if (!this.isPaused && !this.isSliding) this.next();
    }, this.interval);
  }

  pause() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
    this.isPaused = true;
  }

  getActiveIndex() {
    return this.items.findIndex(i => i.classList.contains('active'));
  }

  updateIndicators() {
    this.indicators.forEach((el, i) => {
      const active = i === this.currentIndex;
      el.classList.toggle('active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  }

  to(index) {
    if (index < 0 || index >= this.items.length || index === this.currentIndex || this.isSliding) return;
    const from = this.currentIndex, to = index;
    this.el.dispatchEvent(new CustomEvent('slide.bs.carousel', { detail: { from, to } }));
    this.isSliding = true;
    this.isFade ? this._fade(from, to) : this._slide(from, to);
  }

  _slide(from, to) {
    const cur = this.items[from], next = this.items[to];
    const isNext = to > from || (from === this.items.length - 1 && to === 0);
    next.classList.add(`carousel-item-${isNext ? 'next' : 'prev'}`);
    next.offsetHeight;
    cur.classList.add(`carousel-item-${isNext ? 'start' : 'end'}`);
    next.classList.add(`carousel-item-${isNext ? 'start' : 'end'}`);

    const end = () => {
      cur.classList.remove('active', 'carousel-item-start', 'carousel-item-end');
      next.classList.remove('carousel-item-next', 'carousel-item-prev', 'carousel-item-start', 'carousel-item-end');
      next.classList.add('active');
      this.currentIndex = to;
      this.isSliding = false;
      this.updateIndicators();
      this.el.dispatchEvent(new CustomEvent('slid.bs.carousel', { detail: { from, to } }));
      next.removeEventListener('transitionend', end);
      if (this.wasCycling && this.interval) this.cycle();
    };
    next.addEventListener('transitionend', end);
  }

  _fade(from, to) {
    this.items[from].classList.remove('active');
    this.items[to].classList.add('active');
    setTimeout(() => {
      this.currentIndex = to;
      this.isSliding = false;
      this.updateIndicators();
      this.el.dispatchEvent(new CustomEvent('slid.bs.carousel', { detail: { from, to } }));
      if (this.wasCycling && this.interval) this.cycle();
    }, 10);
  }

  _nav(d) {
    if (this.isSliding) return;
    let i = this.currentIndex + d;
    if (i < 0) i = this.items.length - 1;
    if (i >= this.items.length) i = 0;
    this.to(i);
  }

  prev() { this.pause(); this._nav(-1); }
  next() { this.pause(); this._nav(1); }

  handleTouchStart(e) { if (!this.isSliding) this.touchStartX = e.touches[0].clientX; }
  handleTouchMove(e) { if (!this.isSliding) this.touchDeltaX = e.touches[0].clientX - this.touchStartX; }
  handleTouchEnd() {
    if (this.isSliding) return;
    const t = 40;
    if (this.touchDeltaX > t) this.prev();
    else if (this.touchDeltaX < -t) this.next();
  }

  bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    this.indicators.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        this.pause();
        const i = parseInt(el.dataset.bsSlideTo, 10);
        if (!isNaN(i)) this.to(i);
      });
    });

    this.el.addEventListener('mouseenter', () => {
      if (this.timer) { this.wasCycling = true; this.pause(); }
      else this.wasCycling = false;
    });

    this.el.addEventListener('mouseleave', () => {
      if (this.wasCycling && this.interval) this.cycle();
    });

    this.el.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
    });

    this.el.addEventListener('touchstart', e => this.handleTouchStart(e), { passive: true });
    this.el.addEventListener('touchmove', e => this.handleTouchMove(e), { passive: false });
    this.el.addEventListener('touchend', () => this.handleTouchEnd(), { passive: true });
  }

  getCurrentIndex() { return this.currentIndex; }
  getItemCount() { return this.items.length; }
  destroy() { this.pause(); }
}
/**
 * simple tabs class for bs tabs
 */
class SimpleTabs {
  constructor(selector) {
    this.el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!this.el) {
      console.error('SimpleTabs: Container not found');
      return;
    }

    this.triggers = this.el.querySelectorAll('[data-bs-toggle="tab"], [data-bs-toggle="pill"]');
    if (this.triggers.length === 0) {
      console.error('SimpleTabs: No triggers found');
      return;
    }

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.show(trigger);
      });
    });
  }

  show(trigger) {
    if (trigger.classList.contains('active')) return;

    const targetSelector = trigger.getAttribute('data-bs-target') || trigger.getAttribute('href');
    if (!targetSelector || !targetSelector.startsWith('#')) {
      console.error('SimpleTabs: Invalid target selector:', targetSelector);
      return;
    }

    const targetPane = document.querySelector(targetSelector);
    if (!targetPane) {
      console.error('SimpleTabs: Target pane not found:', targetSelector);
      return;
    }

    const prevActiveTrigger = this.el.querySelector('.nav-link.active, .nav-item .active');
    const prevActivePane = this.el.querySelector('.tab-pane.active');

    if (prevActiveTrigger) prevActiveTrigger.classList.remove('active');
    if (prevActivePane) prevActivePane.classList.remove('active', 'show');

    trigger.classList.add('active');
    targetPane.classList.add('active', 'show'); // 直接添加 'show'，简化 fade 逻辑
  }

  showByIndex(index) {
    if (index >= 0 && index < this.triggers.length) {
      this.show(this.triggers[index]);
    } else {
      console.warn('SimpleTabs: Index out of bounds');
    }
  }

  showByTarget(targetSelector) {
    const trigger = this.el.querySelector(`[data-bs-target="${targetSelector}"], [href="${targetSelector}"]`);
    if (trigger) {
      this.show(trigger);
    } else {
      console.warn('SimpleTabs: Trigger not found for:', targetSelector);
    }
  }
}
window.debounce = function(fn, wait = 500) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.throttle = function(fn, wait = 300) {
  let timeoutId = null;
  let lastExecTime = 0;

  return function (...args) {
    const currentTime = Date.now();
    
    if (currentTime - lastExecTime > wait) {
      fn.apply(this, args);
      lastExecTime = currentTime;
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn.apply(this, args);
        lastExecTime = Date.now();
      }, wait - (currentTime - lastExecTime));
    }
  };
}
window.copyInputValue = async function(btn, inputId) {
  const input = document.getElementById(inputId);
  if (!input) return false;
  
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(input.value);
      success = true;
    } catch {
      input.select();
      input.setSelectionRange(0, input.value.length);
      success = document.execCommand('copy');
    }
  } else {
    input.select();
    input.setSelectionRange(0, input.value.length);
    success = document.execCommand('copy');
  }
  
  if (success) {
    const originalText = btn.textContent;
    const copyText = btn?.dataset?.copyText || 'Copied';
    btn.textContent = copyText;
    
    setTimeout(() => {
      btn.textContent = originalText;
    }, 3000);
  }
  
  return success;
}
/**
* Dynamically load JavaScript files
*/
window.loadJs = function(url, options = {}) {
  const settings = {
    cache: true,
    async: true,
    ...options,
    url: url
  };
  
  let src = settings.url;
  if (!settings.cache) {
    const separator = src.includes('?') ? '&' : '?';
    src += separator + '_=' + Date.now();
  }
  
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = settings.async;
    
    Object.keys(settings).forEach(key => {
      if (['crossOrigin', 'integrity', 'defer', 'referrerPolicy'].includes(key) && settings[key]) {
        script[key] = settings[key];
      }
    });
    
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load: ${url}`));
    document.head.appendChild(script);
  });
};
/**
 * Dynamically load css files
 */
window.loadCSS = function(url, options = {}) {
  const settings = {
    cache: true,
    media: 'all',
    ...options,
    url: url
  };
  
  let href = settings.url;
  if (!settings.cache) {
    const separator = href.includes('?') ? '&' : '?';
    href += separator + '_=' + Date.now();
  }
  
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.media = settings.media;
    
    Object.keys(settings).forEach(key => {
      if (['crossOrigin', 'integrity', 'referrerPolicy'].includes(key) && settings[key]) {
        link[key] = settings[key];
      }
    });
    
    link.onload = () => resolve(link);
    link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
    document.head.appendChild(link);
  });
};
/**
 * load css/js by url
 */
window.loadByUrl = function(url, cb, opts = {}) {
  const {
    type = 'js',
    chk = null,
    force = false,
    ...loadOpts
  } = opts;

  const key = `${type}:${url}`;
  const isJs = type === 'js';
  const store = isJs ? window.jsLoadStatus : window.cssLoadStatus;

  if (!force) {
    if (chk) {
      const isReady = isJs 
        ? typeof window[chk] !== 'undefined' 
        : document.getElementById(chk);
      if (isReady) {
        cb();
        return;
      }
    }

    const status = store.get(key);
    if (status === 'loaded') {
      cb();
      return;
    } else if (status === 'loading') {
      const cbs = store.get(`${key}_cbs`) || [];
      cbs.push(cb);
      store.set(`${key}_cbs`, cbs);
      return;
    }
  }

  store.set(key, 'loading');
  const cbs = [cb];
  store.set(`${key}_cbs`, cbs);

  const loader = isJs ? window.loadJs : window.loadCSS;

  loader(url, loadOpts)
    .then((res) => {
      store.set(key, 'loaded');

      if (!isJs && chk && res) {
        res.id = chk;
      }

      const queued = store.get(`${key}_cbs`) || [];
      const finalCallbacks = [...queued];

      finalCallbacks.forEach((callback) => {
        try {
          if (isJs && chk) {
            if (typeof window[chk] !== 'undefined') {
              callback();
            } else {
              const err = new Error(`${chk} is not available after loading ${url}`);
              console.error(err.message);
              callback(null, err);
            }
          } else {
            callback(res);
          }
        } catch (e) {
          console.error('Callback error:', e);
        }
      });

      store.delete(`${key}_cbs`);
    })
    .catch((err) => {
      store.set(key, 'error');
      const queued = store.get(`${key}_cbs`) || [];
      const finalCallbacks = [...queued];

      finalCallbacks.forEach((callback) => {
        try {
          callback(null, err);
        } catch (e) {
          console.error('Callback error:', e);
        }
      });

      console.error(`Failed to load ${url}:`, err);
      store.delete(`${key}_cbs`);
    });
};
/**
 * init Intersection Observer
 */
window.initLazyObserver = function(element, callback, threshold = 50){
  if('IntersectionObserver' in window){
    const debouncedCallback = debounce(callback, 100);
    
    const io = new IntersectionObserver((entries, observe)=>{
      entries.forEach((entry)=>{
        if(entry.isIntersecting){
          debouncedCallback();
          observe.unobserve(entry.target);
        }
      });
    }, {rootMargin:`0px 0px ${threshold}px 0px`});
    
    io.observe(element);
  }else{
    callback();
  }
}
/**
 * init Dynamic Intersection Observer
 */
window.initDynamicObserver = function(selectorsAndHandlers = {}){
  const mo = new MutationObserver(mutations=>{
    mutations.forEach(mutation=>{
      mutation.addedNodes.forEach(node=>{
        if(node.nodeType === 1){
          Object.keys(selectorsAndHandlers).forEach(selector=>{
            const handler = selectorsAndHandlers[selector];
            if(handler && typeof handler === 'function'){
              if(node.matches?.(selector)){
                initLazyObserver(node,() => handler(node));
              }
              node.querySelectorAll?.(selector)?.forEach(el => {
                initLazyObserver(el,() => handler(el));
              });
            }
          });
        }
      });
    });
  });
  mo.observe(document.body, {childList:true, subtree:true});
  return mo;
}
/**
 * Event Delegation
 */
window.initEventDelegation = function(events, opts = {}) {
  const {
    target  = document,
    capture = false,
    once    = false,
    passive = false,
  } = opts;

  const cleanups = [];

  Object.keys(events).forEach(type => {
    const handlers = Array.isArray(events[type]) ? events[type] : [events[type]];
    const handlerFn = (e) => {
      handlers.forEach(cfg => {
        let sel, fn, opt;
        if (typeof cfg === 'function') {
          cfg(e);
          return;
        }

        if (cfg && typeof cfg === 'object') {
          sel = cfg.selector;
          fn = cfg.handler;
          opt = cfg.options;

          if (!fn || typeof fn !== 'function') return;

          const isMatch = !sel || (
            typeof sel === 'string' ? 
              e.target.matches(sel) || e.target.closest?.(sel) :
            sel instanceof Element ?
              e.target === sel || sel.contains(e.target) :
            Array.isArray(sel) || sel instanceof NodeList ?
              [...sel].some(el => e.target === el || el.contains(e.target)) :
            false
          );

          if (isMatch) {
            if (opt?.once) {
              const key = `${type}-${fn}`;
              if (e.target[key]) return;
              e.target[key] = true;
            }
            fn(e);
          }
        }
      });
    };

    const eventOpts = { capture, once, passive };
    target.addEventListener(type, handlerFn, eventOpts);
    cleanups.push(() => target.removeEventListener(type, handlerFn, eventOpts));
  });

  return {
    destroy: () => cleanups.forEach(cleanup => cleanup()),
    addHandler: (type, cfg) => {
      if (!events[type]) events[type] = [];
      events[type].push(cfg);
    },
  };
};
/**
 * Show momal by template
 */
function TemplateModal(event, selector) {
  if (event) {
    event.preventDefault();
  }
  const template = document.querySelector(selector);
  if (!template) {
    console.error("Template not found:", selector);
    return;
  }

  const clone = document.importNode(template.content, true);

  const modal = clone.querySelector('.modal');
  if (!modal) {
    console.error("Modal element not found inside template");
    return;
  }

  document.body.appendChild(modal);

  SimpleModal.show(modal);

  modal.addEventListener('hidden.bs.modal', function () {
    modal.remove();
  }, { once: true });
}
/**
 * init swiper slide
 */
function initSwiper(element){
  if(element?.classList?.contains('swiper-initialized')) return;

  Promise.all([
    loadByUrl(theme?.static?.swiperCss, () => {}, { type: 'css', check: 'swipercss' }),
    new Promise((resolve, reject) => {
      loadByUrl(theme?.static?.swiperJs, () => {
        if (typeof window.Swiper !== 'undefined') {
          resolve(window.Swiper);
        } else {
          reject(new Error('Swiper failed to load'));
        }
      }, { type: 'js', check: 'Swiper' });
    })
  ]).then(([_, SwiperConstructor]) => {
    const configStr = element?.dataset?.config;
    if (!configStr) return;

    let swiperConfig;
    try {
      swiperConfig = JSON.parse(configStr);
    } catch (e) {
      console.error('Invalid swiper config:', e);
      return;
    }

    if (swiperConfig?.navigation) {
      ['prevEl', 'nextEl', 'el'].forEach(key => {
        if (swiperConfig.navigation[key] && typeof swiperConfig.navigation[key] === 'string') {
          const el = element.querySelector(swiperConfig.navigation[key]);
          if (el) swiperConfig.navigation[key] = el;
        }
      });
    }

    const swiper = new SwiperConstructor(element, swiperConfig);

  }).catch(err => {
    console.error('Swiper initialization failed:', err);
  });
}
/**
 * init load driver on tooltip or popover
 */
let driver;
function initDriver(element){
  Promise.all([
    loadByUrl(theme?.static?.driverCss, () => {}, { type: 'css', check: 'drivercss' }),
    new Promise((resolve, reject) => {
      loadByUrl(theme?.static?.driverJs, () => {
        if ( typeof window.driver?.js?.driver === 'function' ) {
          resolve();
        } else {
          reject(new Error('Driver.js failed to load or driver is not a function'));
        }
      }, { type: 'js', check: 'driver' });
    })
  ]).then(() => {
    driver = window.driver.js.driver();
  }).catch(err => {
    console.error('driver.js load fail:', err);
  });
}
// show tooltip config
function showTooltip(element) {
  if (driver) driver.destroy();
  driver = window.driver.js.driver({overlayOpacity:0});
  driver.highlight({
    element: element,
    popover: {
      side:element.dataset?.side || 'top',
      description: element.title
    }
  });
}
// show popover config
function showPopover(element, html='') {
  if (driver) driver.destroy();
  driver = window.driver.js.driver({overlayOpacity:0.7});
  driver.highlight({
    element: element,
    popover: {
      description: html ? html : element.title
    }
  });
}
/**
 * init aos load
 */
function loadAOS() {
  const settings = window?.theme?.settings;
  if (!settings) {
    console.warn('Theme settings not found; skipping AOS load.');
    return;
  }
  const isDesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const shouldLoad = isDesktop ? settings.animations === true : settings.animationsMob === true;

  if (!shouldLoad) {
    return;
  }
  Promise.all([
    loadByUrl(theme?.static?.aosCss, () => {}, { type: 'css', check: 'aoscss' }),
    new Promise((resolve, reject) => {
      loadByUrl(theme?.static?.aosJs, () => {
        if (typeof window.AOS !== 'undefined' && typeof window.AOS.init === 'function') {
          resolve();
        } else {
          reject(new Error('AOS failed to load or init is not a function'));
        }
      }, { type: 'js', check: 'AOS' });
    })
  ]).then(() => {
    requestAnimationFrame(() => {
      AOS.init();
    });
  }).catch(err => {
    console.error('driver load fail:', err);
  });
}
/**
 * init load nice select2
 */
function initSelect2(element){
  Promise.all([
    loadByUrl(theme?.static?.niceSelect2Css, () => {}, { type: 'css', check: 'niceselect2css' }),
    new Promise((resolve, reject) => {
      loadByUrl(theme?.static?.niceSelect2Js, () => {
        if (typeof window.NiceSelect?.bind === 'function') {
          resolve();
        } else {
          reject(new Error('NiceSelect failed to load or bind is not a function'));
        }
      }, { type: 'js', check: 'NiceSelect' });
    })
  ]).then(() => {
    if (element.nextElementSibling && element.nextElementSibling.classList.contains('nice-select')) {
      element.nextElementSibling.remove();
    }
    const {
      searchable,
      searchtext,
      placeholder,
      dropdownClass,
      templateResult,
      templateSelection,
      countryFlag,
      customInput
    } = element.dataset;

    let config = {searchable, searchtext, placeholder, dropdownClass, customInput};
    
    if (templateResult && typeof window[templateResult] === 'function') {
      config.templateResult = window[templateResult];
    }
    
    if (templateSelection && typeof window[templateSelection] === 'function') {
      config.templateSelection = window[templateSelection];
    }

    NiceSelect.bind(element, config);

  }).catch(err => {
    console.error('nice-select2 load fail:', err);
  });
}
/**
 * init load Translate.js
 */
function initTranslatejs(element){
  const langCode = 'zh,zh-CN,zh-TW,zh-HK,co,gn,rw,ha,no,nl,yo,en,en-US,kok,la,ne,fr,cs,haw,ka,ru,fa,bho,hi,be,sw,is,yi,tw,ga,gu,km,sk,he,kn,hu,ta,ar,bn,az,sm,af,id,da,sn,bm,lt,vi,mt,tk,as,ca,si,ceb,gd,sa,pl,gl,lv,uk,tt,cy,ja,fil,ay,lo,te,ro,ht,doi,sv,mai,th,hy,my,ps,hmn,dv,lb,sd,ku,tr,mk,bg,ms,lg,mr,et,ml,de,sl,ur,pt,ig,ckb,om,el,es,fy,so,am,ny,pa,eu,it,sq,ko,tg,fi,ky,ee,hr,kri,qu,bs,mi,';

  new Promise((resolve, reject) => {
    loadByUrl(theme?.static?.translateJs, () => {
      if (
        typeof window.translate !== 'undefined' &&
        typeof window.translate.selectLanguageTag !== 'undefined' &&
        typeof window.translate.service !== 'undefined' &&
        typeof window.translate.execute === 'function'
      ) {
        resolve();
      } else {
        reject(new Error('Translate.js failed to initialize'));
      }
    }, { type: 'js', check: 'translate' });
  })
  .then(() => {
    const { translateAutolocal } = element.dataset;
    translate.selectLanguageTag.show = false;
    translate.service.use('client.edge');
    if (translateAutolocal) {
      translate.setAutoDiscriminateLocalLanguage();
    }
    const curlang = translate.language.getCurrent();
    const eleVal = langCode.indexOf(element.value + ',') > -1 
      ? translate.util.browserLanguage[element.value] || element.value 
      : element.value;
    if (eleVal != curlang) {
      element.querySelectorAll('option').forEach(option => {
        const optVal = langCode.indexOf(option.value + ',') > -1 
          ? translate.util.browserLanguage[option.value] || option.value 
          : option.value;
        if (optVal == curlang) {
          option.selected = true;
          option.setAttribute('selected', 'selected');
        } else {
          option.selected = false;
          option.removeAttribute('selected');
        }
      });
      initSelect2(element);
    }
    translate.execute();
  })
  .catch(err => {
    console.error('Translate.js initialization failed:', err);
  });
}
/**
 * init load google translate
 */
let gTransInited = false;
const GTRANS_KEY = 'gtrans_last_req';
const GTRANS_MIN = 5000;
function initGoogleTranslate(el) {
  const last = sessionStorage.getItem(GTRANS_KEY);
  const now = Date.now();

  if (last && (now - parseInt(last)) < GTRANS_MIN) return;

  sessionStorage.setItem(GTRANS_KEY, now.toString());

  new Promise((resolve, reject) => {
    loadByUrl(theme?.static?.googleTransJs, () => {
      if ( typeof window.google?.translate?.TranslateElement === 'function' ) {
        resolve();
      } else {
        let attempts = 0;
        const maxAttempts = 100;
        const poll = setInterval(() => {
          attempts++;
          if ( typeof window.google?.translate?.TranslateElement === 'function' ) {
            clearInterval(poll);
            resolve();
          } else if (attempts >= maxAttempts) {
            clearInterval(poll);
            reject(new Error('Google Translate API not available'));
          }
        }, 100);
      }
    },
    { type: 'js', check: 'google' });
  })
  .then(() => {
    const { pageLanguage, includedLanguages } = el.dataset;

    try {
      new google.translate.TranslateElement({
          pageLanguage,
          includedLanguages,
        },
        'google_translate_element'
      );

      gTransInited = true;

      const curlang = (document.cookie.match(/(?:^|; )googtrans=([^;]*)/) || [])[1] ||
        `/${pageLanguage}`;
      const savedlang = curlang.split('/').pop();
      el.value = savedlang;

      initSelect2(el);
    } catch (err) {
      console.error('Google Translate initialization failed:', err);
    }
  })
  .catch((err) => {
    console.error('Google Translate load failed:', err);
  });
}
/**
 * Search form
 */
function initformSearch(element){
  const searchBox = element.querySelector('.searchbox');
  const predictiveSearch = element.querySelector('.predictive-search');
  const searchPredictive = element.dataset.searchPredictive;

  if (!searchBox || !predictiveSearch) return;

  let oldSearchKey = '';

  const getPredictive = (keyword) => {
    if (getPredictive.controller) {
      getPredictive.controller.abort();
    }
    
    getPredictive.controller = new AbortController();
    
    return fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(keyword)}&section_id=predictive-search`, {
      signal: getPredictive.controller.signal
    })
    .then(response => response.text())
    .then(data => {
      if (data) {
        predictiveSearch.innerHTML = data;
      }
      return data;
    })
    .catch(error => {
      if (error.name !== 'AbortError') {
        console.error('Request failed:', error);
      }
      throw error;
    });
  };

  const handleSearch = (keyword) => {
    if (keyword.length && keyword !== oldSearchKey) {
      getPredictive(keyword)
        .catch(error => {
          if (error.name !== 'AbortError') {
            console.error('Search failed:', error);
          }
        });
    } else if (!keyword.length) {
      predictiveSearch.innerHTML = '';
      if (getPredictive.controller) {
        getPredictive.controller.abort();
      }
    }
    oldSearchKey = keyword;
  };

  const debouncedSearch = debounce(handleSearch, 500);
  if (searchPredictive) {
    searchBox.addEventListener('input', (e) => {
      debouncedSearch(e.target.value);
    });
  }

  initEventDelegation({
    click:[
      {
        selector:'body',
        handler: (e) => {
          if(!e.target.closest('.input-group')){
            element.classList.remove('active');
          }
        }
      }
    ],
    focusin:[
      {
        selector:searchBox,
        handler: (e) => {
          element.classList.add('active');
        }
      }
    ]
  });
}
/**
 * faq search
 */
function initFAQSearch(element) {
  const faq = element.closest('.faq');
  const items = faq.querySelectorAll('.collapsible-tab');
  const itemData = Array.from(items).map(el => ({
    el: el,
    keywords: el.dataset.keywords.toLowerCase()
  }));
  
  element.addEventListener('input', function() {
    const searchTerm = this.value.trim().toLowerCase();
    itemData.forEach(({el, keywords}) => {
      el.style.display = keywords.includes(searchTerm) ? '' : 'none';
    });
  });
}
/**
 * key features section
 */
function initKeyFeatures(element) {
  const featurestext = element.querySelector('.features-text');
  if (!featurestext) return;

  const keyFeatureElements = element.querySelectorAll('.key-feature');
  if (keyFeatureElements.length === 0) return;

  const elementRect   = element.getBoundingClientRect();
  const elementTop    = elementRect.top + window.pageYOffset;
  const elementBottom = elementTop + elementRect.height;
  const windowHeight  = window.innerHeight;

  const featuresData = [];
  keyFeatureElements.forEach((e, i) => {
    if (i === 0) {
      featurestext.innerHTML = e.querySelector('.feature-text').innerHTML;
    }
    const featureRect = e.getBoundingClientRect();
    featuresData.push({
      top: featureRect.top + window.pageYOffset,
      text: e.querySelector('.feature-text').innerHTML,
      bg: e.dataset.bg
    });
  });

  const ioKeyFeatures = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!element.scrollHandler) {
          element.scrollHandler = () => {
            requestAnimationFrame(() => {
              const scrollBottom = window.pageYOffset + windowHeight;
              let activeFeatureIndex = -1;

              for (let i = featuresData.length - 1; i >= 0; i--) {
                const feature = featuresData[i];
                const featureTriggerPoint = feature.top + (windowHeight / 2);
                if (scrollBottom > featureTriggerPoint) {
                  activeFeatureIndex = i;
                  break;
                }
              }

              if (activeFeatureIndex !== -1) {
                const activeFeature = featuresData[activeFeatureIndex];
                element.style.setProperty('--theme-keyfeatures-opacity', '1');
                element.style.setProperty('--theme-keyfeatures-bg', activeFeature.bg);
                featurestext.innerHTML = activeFeature.text;
              }
            });
          };

          window.addEventListener('scroll', element.scrollHandler, { passive: true });
        }
      } else {
        if (element.scrollHandler) {
          window.removeEventListener('scroll', element.scrollHandler);
          delete element.scrollHandler;
        }
      }
    });
  }, {
    rootMargin: '0px',
    threshold: 0.1
  });

  ioKeyFeatures.observe(element);

  element.cleanupKeyFeatures = () => {
    if (element.scrollHandler) {
      window.removeEventListener('scroll', element.scrollHandler);
      delete element.scrollHandler;
    }
    ioKeyFeatures.disconnect();
  };
}
/**
 * change view for list page
 */
function changeView(name, view) {
  const formData = new FormData();
  formData.append(`attributes[${name}]`, view);
  fetch(theme.routes.cartUpdate, { method: "POST", body: formData })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data.attributes[name] == view) {
        document.location.reload();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}
/**
 * format select on flag
 */
function formatFlags(state) {
  if (!state?.element) return state?.text || '';

  const countryFlag = state.element.closest('select')?.dataset?.countryFlag || false;

  const {
    countryName,
    currency,
    currencySymbol,
    endonymName,
    name,
    rootUrl
  } = state.element.dataset;

  const val = state.element.value.replace(/[\(\)]/g, '').replace(/[\.,]\s/g, '-').replace(/[\'\s]/g, '-').toLowerCase();
  const flag = countryFlag
    ? `<span class="flags flags-xs lazy-flags flex-shrink-1 me-1" data-flag="--${endonymName ? 'lang' : 'flag'}-${val}"></span>`
    : '';

  if (endonymName) {
    return `<div class="d-flex align-items-center text-truncate">${flag}${endonymName}</div>`;
  }

  if (currency) {
    const prefix = countryFlag || countryName
      ? `<span class="d-inline-flex align-items-center text-truncate me-1">${flag}${countryName}</span>`
      : '';
    return `<div class="d-flex align-items-center justify-content-between">${prefix}<span class="currency-symbol">${currency}${currencySymbol}</span></div>`;
  }

  return `<div class="d-flex align-items-center text-truncate">${flag}${state.text}</div>`;
}
/**
 * format variant select
 */
function formatVariantOpt(state) {
  if (!state || !state.element) return state?.text || '';

  const {color,image,available,size,style} = state.element.dataset;
  const bg = color ? color : image ? `url(${image})` : '';
  const icon = bg ? `<span class="${style}" style="--tblr-avatar-bg:${bg};"></span>` : '';

  return `<div class="d-flex align-items-center justify-content-between ${available?'disabled':''}"><span class="d-flex align-items-center">${icon}<span class="ms-2">${state.text}</span></span>${available?'<span class="fst-italic">'+available+'</span>':''}</div>`;
}
/**
 * handle for quick buy button click
 */
function handleQuickbuyToggle(e){
  e.preventDefault();
  const quickbuyBtn = e.target.closest('.quickbuy-toggle');
  const cardProduct = quickbuyBtn.closest('.card-product');
  const productId = cardProduct?.dataset?.productId || '';
  if(!quickbuyBtn || !cardProduct || !productId) return;

  const productUrl = quickbuyBtn.getAttribute('href');
  const quickbuyId = `quickbuy-${productId}`;
  let modalElement = document.getElementById(quickbuyId);
  if (!modalElement) {
    const modalHtml = `<div id="${quickbuyId}" class="modal fade">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h3">${cardProduct.querySelector('.card-title').innerHTML}</div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" aria-hidden="false"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <div class="spinner-border" role="status" style="--tblr-spinner-width:3rem;--tblr-spinner-height:3rem;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHtml.trim();
    modalElement = tempDiv.firstChild;
    document.body.appendChild(modalElement);
  }
  SimpleModal.show(modalElement);

  const modalBody = modalElement.querySelector('.modal-body');
  if(!modalBody) return;
  
  fetch(productUrl).then(response => response.text()).then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const quickbuyContent = doc.querySelector('product-form');

    if (quickbuyContent) {
      const notInQuickbuyElements = quickbuyContent.querySelectorAll('.not-in-quickbuy');
      notInQuickbuyElements.forEach(el => el.remove());

      doc.querySelectorAll('script[src]').forEach(el => {
        if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
          const scr = document.createElement('script');
          scr.src = el.getAttribute('src');
          scr.defer = 'defer';
          document.head.appendChild(scr);
        }
      });

      const productUrlObj = new URL(productUrl, window.location.origin);
      const searchParams = productUrlObj.searchParams;

      modalBody.innerHTML = quickbuyContent.outerHTML;

      const variantPicker = modalBody.querySelector('variant-picker');
      customElements.whenDefined('variant-picker').then(() => {
        if (variantPicker && typeof variantPicker.processSearchParams === 'function') {
          variantPicker.processSearchParams(searchParams);
        }
      }).catch(error => {
        console.error(error);
      });
    }else{
      modalBody.innerHTML = '<h2>Content not found</h2>';
    }
  }).catch(error => {
    console.error(error);
    modalBody.innerHTML = '<h2>Loading failed</h2>';
  });

}
/**
 * handle for car product variant selected
 */
function handleCardVariant(e){
  e.preventDefault();
  const variantLabel = e.target.closest('.variant-label');
  const cardVariant  = variantLabel?.closest('.card-variant');
  const mediaId      = variantLabel?.dataset?.media || '';
  const cardProduct  = variantLabel?.closest('.card-product');
  const cardCarousel = cardProduct?.querySelector('.carousel');

  if(!variantLabel || !cardVariant) return;
  cardVariant.querySelectorAll('.variant-label').forEach(el => el.classList.remove('active'));
  variantLabel.classList.add('active');

  if(!cardProduct || !cardCarousel || !mediaId) return;

  let index = cardCarousel.querySelector(`.carousel-indicators [data-media-id="${mediaId}"]`)?.dataset?.bsSlideTo;
  if(index !== undefined){
    index = parseInt(index);
    cardCarousel.dispatchEvent(new CustomEvent('simplecarousel:toSlide', {
      detail: { index: index }
    }));
  }

  const quickBuyToggle = cardProduct.querySelector('.quickbuy-toggle');
  if(!quickBuyToggle) return;

  const optionName = cardVariant?.dataset?.optionName || '';
  const optionItem = variantLabel?.dataset?.optionItem || '';
  if(!optionName || !optionItem) return;

  let href = quickBuyToggle.getAttribute('href');
  if (href.indexOf('http') === -1) {
    href = window.location.origin + href;
  }
  const url = new URL(href);
  const params = new URLSearchParams(url.search);
  params.set(optionName, optionItem);
  quickBuyToggle.setAttribute('href', `${url.pathname}?${params.toString()}`);
}
/**
 * handle for cart note chage
 */
window.cartNoteChange = function(e){
  if(!window?.theme?.routes?.cartUpdate) return;

  fetch(theme.routes.cartUpdate, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ note: e.target.value })
  }).then(response => response.json()).then(data => {
    console.log(data);
  }).catch(error => {
    console.error(error);
  });
}
/**
 * button status update
 */
window.updateBtnStatus = function(btn, status = false, updateSticky = true) {
  if (!btn) return;

  let btnText = btn.dataset.btnText || '';
  if (!btnText) {
    btnText = btn.textContent;
    btn.dataset.btnText = btnText;
  }

  if (status) {
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner-border" role="status"></span>';
  } else {
    btn.disabled = false;
    btn.innerHTML = btnText;
  }
  
  if (updateSticky && stickyBtn) {
    window.updateBtnStatus(stickyBtn, status, false);
  }
}
/**
 * parse variant qty range
 */
window.parseQtyTable = function(rawQtys) {
  return rawQtys
    .map((raw) => {
      const str = String(raw).trim();
      const rangeMatch = str.match(/^(\d+)(?:[–-](\d+))?$/);
      if (rangeMatch) {
        return {
          label: str,
          min: Number(rangeMatch[1]),
          max: Number(rangeMatch[2] || rangeMatch[1]),
        };
      }
      const plusMatch = str.match(/^(\d+)\+$/);
      if (plusMatch) {
        return {
          label: str,
          min: Number(plusMatch[1]),
          max: Infinity,
        };
      }
      return null;
    })
    .filter(Boolean);
}
/**
 * get qty discount table
 */
window.getQtyTable = function(variants) {
  const uniqueOptions = (index) =>
    [...new Set(variants.map((item) => item[`option${index}`]))];

  for (let i = 1; i <= 3; i++) {
    const unique = uniqueOptions(i);
    const qty = this.parseQtyTable(unique);
    if (qty.length) return { index: i, table: qty };
  }
  return null;
}
/**
 * check cart and merge variant
 */
window.checkCart = async function(data, cb) {
  let productId, variantId, quantity;

  if(data.updates){
    productId             = data.productId;
    [variantId, quantity] = Object.entries(data.updates)[0];
  } else if(data.formData){
    const formObject = Object.fromEntries(data.formData.entries());
    productId        = formObject['product-id'];
    variantId        = formObject.id;
    quantity         = formObject.quantity
  }

  if(quantity == 0){
    cb(data);
    return;
  }

  const productVariants = window.theme.productVariants?.[productId];

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const foundItems = cart.items.filter(item => item.product_id == productId);
    
    if (foundItems.length > 0) {
      const { index, table } = window.getQtyTable(productVariants);
      const optionType       = productVariants?.[0].options.length;
      const curVariant       = productVariants.find(r => variantId == r.id);
      let optionKey          = { opt1: 'option1', opt2: 'option2', opt3: 'option3' };
      let cartQuantity       = 0;
      let foundItemsVar      = null;
      
      if (optionType == 2) {
        if (index == 2) {
          optionKey.opt1 = 'option2';
          optionKey.opt2 = 'option1';
        }
      } else if (optionType == 3) {
        if (index == 2) {
          optionKey.opt1 = 'option2';
          optionKey.opt2 = 'option1';
        } else if (index == 3) {
          optionKey.opt1 = 'option3';
          optionKey.opt2 = 'option1';
          optionKey.opt3 = 'option2';
        }
      }
      
      if (optionType == 1) {
        cartQuantity = foundItems.reduce((sum, item) => sum + item.quantity, 0);
      } else {
        if (optionType == 2) {
          foundItemsVar = foundItems.find(item => item.variant_options.includes(curVariant[optionKey.opt2]));
        } else {
          foundItemsVar = foundItems.find(item => 
            item.variant_options.includes(curVariant[optionKey.opt2]) && 
            item.variant_options.includes(curVariant[optionKey.opt3])
          );
        }
        
        if (foundItemsVar) {
          cartQuantity = foundItemsVar.quantity;
        }
      }
      
      let totalQuantity = Number(quantity);
      if(data.formData) totalQuantity = totalQuantity + cartQuantity;
      const newQty = table.find(r => totalQuantity >= r.min && totalQuantity <= r.max);
      
      const newVariant = optionType == 1 
        ? productVariants.find(r => newQty.label == r[optionKey.opt1]) : foundItemsVar 
        ? optionType == 2 
        ? productVariants.find(r => newQty.label == r[optionKey.opt1] && curVariant[optionKey.opt2] == r[optionKey.opt2]) : optionType == 3 
        ? productVariants.find(r => newQty.label == r[optionKey.opt1] && curVariant[optionKey.opt2] == r[optionKey.opt2] && curVariant[optionKey.opt3] == r[optionKey.opt3]) : undefined : undefined;
      
      if (newVariant) {
        let updates = optionType == 1 
          ? Object.fromEntries(foundItems.map(({ id }) => [id, 0])) 
          : { [foundItemsVar.id]: 0 };

        updates[newVariant.id] = totalQuantity;

        data.updates = updates;
        cb(data);
      } else {
        cb(data);
      }
    } else {
      cb(data);
    }
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}
/**
 * add or update cart
 */
window.updateCart = function(data){
  let postUrl, postData, headers = {};
  if(data.updates){
    postUrl = window.theme.routes.cartUpdate;
    const newData = Object.assign({}, data);
    delete newData.stapos;
    postData = JSON.stringify(newData);
    headers = {'Content-Type': 'application/json'};
  }else if (data.formData){
    postUrl = window.theme.routes.cartAdd;
    postData = data.formData;
  }

  fetch(postUrl, {
    method: 'POST',
    headers: headers,
    body: postData
  })
  .then((res) => res.json())
  .then(response => {
    if(data?.stapos?.posType == 'cartform'){
      window.location.reload();
    }else{
      if (window.theme.settings.afterAddToCart === 'page'){
        window.location.href = window.theme.routes.cart;
      }else{
        if (response.sections) {
          Object.entries(response.sections).forEach(([index, val]) => {
            const section = document.querySelector(`[data-section-id="${index}"]`);
            if (section) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(val, 'text/html');
              const innerCartSidebar = doc.querySelector('.cart-sidebar');
              if (innerCartSidebar) {
                section.innerHTML = innerCartSidebar.innerHTML;
                const cartNum = doc.getElementById('cart-num')?.textContent?.trim() || '0';
                const cartCount = document.getElementById('cart-count');
                if (cartCount) {
                  cartCount.textContent = cartNum === '0' ? '' : cartNum;
                  cartCount.classList.toggle('d-none', cartCount.dataset.showCount !== 'true' || !cartNum || cartNum === '0');
                }
              }
            }
          });
        }

        if (window.theme.settings.afterAddToCart === 'notification') {
          const popoverContent = `${response.product_title} Added to your <a href="">Cart</a>`;
          const cartLink = document.querySelector('.cart-link');
          if(cartLink){
            showPopover(cartLink, popoverContent);
          }
        }else if (window.theme.settings.afterAddToCart === 'sidebar' && !data.silent) {
          if(data?.stapos?.posType == 'productform'){
            SimpleOffcanvas.toggle(data?.stapos?.posEl);
          }
        }
        if(data.stapos){
          const el = data.stapos?.staEl;
          if(el){
            if(data.stapos?.staType == 'btn') window.updateBtnStatus(el);
            if(data.stapos?.staType == 'load') el.classList.remove('ccloading');
          }
        }
      }
    }
  })
  .catch((error) => {
    console.error('updateCart Error:', error);
  });
}
/**
 * web component for quantity input
 */
if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.qtyMinus  = this.querySelector('.qty-minus');
      this.qtyPlus   = this.querySelector('.qty-plus');
      this.qtyRemove = this.querySelector('.qty-remove');
      this.quantity  = this.querySelector('.quantity');
      if (!this.quantity) return;

      this.productId     = this.quantity?.dataset?.productId || '';
      this.variantId     = this.quantity?.dataset?.variant || '';
      this.productForm   = this.closest('product-form') || null;
      this.cartForm      = this.closest('.cart-form') || null;
      this.cartSidebar   = this.closest('.cart-sidebar') || null;

      this.variantData = window.theme?.productVariants?.[this.productId] || null;
      if(this.variantData){
        this.qtyTabls      = window.getQtyTable(this.variantData);
      }else if(this.productForm){
        this.variantPicker = this.productForm.querySelector('variant-picker');
        if(this.variantPicker){
          customElements.whenDefined('variant-picker').then(() => {
          this.variantData = this.variantPicker.variantData;
          this.qtyTabls    = window.getQtyTable(this.variantData);
          }).catch(error => {
            console.error(error);
          });
        }
      }
      
      requestAnimationFrame(() => {
        this.quantityWidth = this.quantity.clientWidth || 44;
        this.adjustInputWidth(this.quantity.value);
      });

      this.qtyMinus?.addEventListener('click',this.handleQtyChange.bind(this,-1));
      this.qtyPlus?.addEventListener('click', this.handleQtyChange.bind(this,1));
      this.qtyRemove?.addEventListener('click', this.handleRemove.bind(this));
      this.quantity.addEventListener('input', this.handleInput.bind(this));
      this.quantity.addEventListener('change', this.handleChange.bind(this));
      this.productForm?.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(e){
      this.variantData = e.detail?.variantData;
      this.qtyTabls    = window.getQtyTable(this.variantData);
    }

    handleQtyChange(change) {
      const step         = parseInt(this.quantity.getAttribute('step')) || 1;
      const currentValue = parseInt(this.quantity.value) || 1;
      const newValue     = Math.max(1, currentValue + (change * step));
      
      this.quantity.value = newValue;
      this.adjustInputWidth(newValue);
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleInput(e) {
      let value = parseInt(e.target.value);
      if (isNaN(value) || value < 1) {
        value = 1;
      }
      e.target.value = value;
      this.adjustInputWidth(value);
    }

    handleRemove(e){
      this.quantity.value = 0;
      this.adjustInputWidth(0);
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleChange(e) {
      let minVal                = 0;
      if(this.productForm) minVal = 1;
      const value                 = parseInt(e.target.value) || minVal;
      const clampedValue          = Math.max(minVal, value);
      e.target.value              = clampedValue;
      this.adjustInputWidth(clampedValue);

      if(!this.productForm){
        let data = {
          updates:{
            [this.variantId]:e.target.value
          },
          productId:this.productId,
          stapos:{
            staType:'load',
            staEl:this.cartForm?.querySelector('.cart-items-list'),
            posType:'cartform',
            posEl:this.cartform
          },
          silent:true
        };

        if(this.cartSidebar){
          data.sections       = this.cartSidebar.dataset.sectionId;
          data.stapos.staEl   = this.cartSidebar;
          data.stapos.posEl   = this.cartSidebar;
          data.stapos.posType = 'cartsidebar';
        }

        data.stapos.staEl.classList.add('ccloading');

        if(this.qtyTabls && e.target.value > 0){
          window.checkCart(data, window.updateCart);
        }else{
          window.updateCart(data);
        }
      }
    }

    adjustInputWidth(value) {
      const baseWidth = this.quantityWidth || 44;
      const textWidth = this.getTextWidth(value.toString()) || 8;
      const width = (textWidth + baseWidth) + 'px';
      this.quantity.style.width = width;
    }

    getTextWidth(text) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = window.getComputedStyle(this.quantity).font;
      const metrics = context.measureText(text);
      return metrics.width;
    }

  }

  customElements.define('quantity-input', QuantityInput);
}
function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
/**
 * AJAX Infinite Scroll for Collections
 * Loads next page when the trigger element enters viewport.
 * Appends innerHTML of .ajax-product from response to current .ajax-product container.
 * Stops if response contains an element with class "no-more-data" and displays its content.
 */
function initAjaxLoadMore(element) {
  if (!element || element.hasAttribute('data-load-more-initialized')) {
    return;
  }
  element.setAttribute('data-load-more-initialized', 'true');

  let loading          = false;
  let hasMore          = true;
  let observerInstance = null;
  const ajaxContainer  = '.ajax-data';

  function getCurrentPage() {
    const url = new URL(window.location.href);
    return parseInt(url.searchParams.get('page')) || 1;
  }

  function buildNextPageUrl(currentPage) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', currentPage + 1);
    return url.toString();
  }

  async function loadNextPage() {
    if (loading || !hasMore) return;
    loading = true;

    element.innerHTML = '<div class="text-center py-4 fs-2"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';

    const currentPage = getCurrentPage();
    const nextUrl = buildNextPageUrl(currentPage);

    try {
      const response = await fetch(nextUrl);
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      const noMoreDataEl = doc.querySelector('.no-more-data');
      if (noMoreDataEl) {
        hasMore = false;
        element.innerHTML = noMoreDataEl.innerHTML;
        if (observerInstance) {
          observerInstance.unobserve(element);
          observerInstance.disconnect();
        }
        return;
      }

      const ajaxContainerInResponse = doc.querySelector(ajaxContainer);

      if (!ajaxContainerInResponse) {
        throw new Error(`${ajaxContainer} container not found in AJAX response`);
      }

      const newContentHtml = ajaxContainerInResponse.innerHTML;
      if (!newContentHtml.trim()) {
        hasMore = false;
        element.innerHTML = theme?.strings?.NoMore || 'There are no more data!';
        if (observerInstance) {
          observerInstance.unobserve(element);
          observerInstance.disconnect();
        }
        return;
      }

      const curAjaxContainer = document.querySelector(ajaxContainer);
      if (!curAjaxContainer) {
        throw new Error(`The ${ajaxContainer} container is not found on the current page`);
      }

      curAjaxContainer.insertAdjacentHTML('beforeend', newContentHtml);

      const newUrlObj = new URL(nextUrl);
      window.history.replaceState({ page: currentPage + 1 }, '', newUrlObj);

      initLazyElements(curAjaxContainer);

    } catch (err) {
      console.error('AJAX loading failed:', err);
      element.innerHTML = `<div class="text-center py-4">
          <button class="btn btn-outline-dark" onclick="initAjaxLoadMore(document.querySelector('[data-load-more=\"ajax\"]'))">${theme?.strings?.clickRetry}</button>
        </div>`;
    } finally {
      loading = false;
    }
  }

  observerInstance = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loading && hasMore) {
        loadNextPage();
      }
    });
  }, {
    rootMargin: '100px 0px',
  });

  observerInstance.observe(element);
}

function initFormValidation(form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    const originalHTML = submitBtn.innerHTML;

    submitBtn.disabled = true;
    submitBtn.innerHTML = `
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Loading...</span>
    `;

    setTimeout(() => {
      if (!form.checkValidity()) {
        e.stopPropagation();
        form.classList.add('was-validated');
        restoreButton();
        return;
      }
      restoreButton();
    }, 300);

    function restoreButton() {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalHTML;
    }

    form.classList.add('was-validated');
  });
}

/**
 * init scrollspy using IntersectionObserver with data-bs-root-margin support
 */
function initScrollSpy(container) {
  const navSelector = container.getAttribute('data-bs-target');
  if (!navSelector) return;

  const nav = document.querySelector(navSelector);
  if (!nav) return;

  const navLinks = nav.querySelectorAll('.nav-link[href^="#"]');
  const sections = Array.from(navLinks)
    .map(link => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  if (sections.length === 0) return;

  let rootMargin = container.getAttribute('data-bs-root-margin');
  if (!rootMargin) {
    const headerOffset = getComputedStyle(document.documentElement)
      .getPropertyValue('--theme-body-padding')
      .trim() || '80px';
    rootMargin = `-${headerOffset} 0px 0px 0px`;
  }

  let lastActiveId = null;

  const observer = new IntersectionObserver((entries) => {
    const visible = entries
      .filter(entry => entry.isIntersecting)
      .map(entry => entry.target);

    if (visible.length === 0) return;

    visible.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    const topSection = visible[0];

    if (topSection.id === lastActiveId) return;

    navLinks.forEach(link => link.classList.remove('active'));
    const activeLink = Array.from(navLinks).find(
      link => link.getAttribute('href') === `#${topSection.id}`
    );
    if (activeLink) {
      activeLink.classList.add('active');
      lastActiveId = topSection.id;
    }
  }, {
    rootMargin: rootMargin,
    threshold: 0.1
  });

  sections.forEach(section => observer.observe(section));
}

/**
 * Hotspots scroll effect: starts when element is 400px from top of viewport.
 * Applies clip-path: inset(0 round 0) → inset(50px round 16px) over next 300px scroll.
 */
function initHotspotsScroll(element) {
  if (!element || element.hasAttribute('data-hotspots-scroll-initialized')) return;
  element.setAttribute('data-hotspots-scroll-initialized', 'true');

  const MAX_INSET = 50;
  const MAX_RADIUS = 16;
  const ANIMATION_RANGE = 350;
  const TRIGGER_OFFSET = 400; 

  const elementTop = element.getBoundingClientRect().top + window.scrollY;
  const startScrollY = elementTop - TRIGGER_OFFSET;

  element.style.clipPath = 'inset(0px round 0px)';

  const updateClipPath = () => {
    const delta = window.scrollY - startScrollY;
    if (delta < 0) {
      element.style.clipPath = 'inset(0px round 0px)';
      return;
    }
    const progress = Math.min(delta / ANIMATION_RANGE, 1);
    const inset = progress * MAX_INSET;
    const radius = progress * MAX_RADIUS;
    element.style.clipPath = `inset(${inset}px round ${radius}px)`;
  };

  const throttledUpdate = window.throttle(updateClipPath, 16);
  window.addEventListener('scroll', throttledUpdate, { passive: true });

  updateClipPath();

  element.cleanupHotspotsScroll = () => {
    window.removeEventListener('scroll', throttledUpdate);
  };
}
/**
 * all lazy element
 */
function initLazyElements(container = document) {
  const handlers = [
    {
      selector: '.lazy-flags',
      handler: (el) => el.style.setProperty('--flag-svg', `var(${el.dataset.flag})`),
      threshold: 100,
      dynamic: true
    },
    {
      selector: 'img[data-manual-src]',
      handler: (el) => {
        if (el.dataset.manualSrc) el.src = el.dataset.manualSrc;
        if (el.dataset.manualSrcset) el.srcset = el.dataset.manualSrcset;
        el.removeAttribute('data-manual-src');
        el.removeAttribute('data-manual-srcset');
      },
      threshold: 100,
      dynamic: true
    },
    { selector: '[data-carousel="swiper"]', handler: initSwiper, threshold: 300 },
    { selector: '[data-aos]:not([data-aos=""])', handler: loadAOS, threshold: 300 },
    { selector: '[data-translate="translatejs"]', handler: initTranslatejs, threshold: 300 },
    { selector: '[data-translate="googletranslate"]', handler: initGoogleTranslate, threshold: 300 },
    { selector: '[data-select="nice-select2"]', handler: initSelect2, threshold: 300 },
    { selector: '[data-popover="driver"]', handler: initDriver, threshold: 50 },
    { selector: '.form-search', handler: initformSearch, threshold: 50 },
    { selector: '.faq-search', handler: initFAQSearch, threshold: 50 },
    { selector: '.key-features', handler: initKeyFeatures, threshold: 50 },
    { selector: '[data-slide="carousel"]', handler: (el) => new SimpleCarousel(el), threshold: 50 },
    { selector: '.mega-nav-tabs', handler: (el) => new SimpleTabs(el), threshold: 50 },
    { selector: '.mega-nav-pills', handler: (el) => new SimpleTabs(el), threshold: 50 },
    { selector: '[data-load-more="ajax"]', handler: initAjaxLoadMore, threshold: 100, dynamic: true },
    { selector: 'form.needs-validation', handler: initFormValidation, threshold: 100,dynamic: true },
    { selector: '[data-bs-spy="scroll"]', handler: initScrollSpy, threshold: 100 },
    { selector: '[data-scroll="hotspots"]', handler: initHotspotsScroll, threshold: 0, dynamic: true }
  ];

  handlers.forEach(({ selector, handler, threshold }) => {
    container.querySelectorAll?.(selector)?.forEach(el => {
      if (isInViewport(el)) {
        handler(el);
      } else {
        initLazyObserver(el, () => handler(el), threshold);
      }
    });
  });

  const dynamicHandlers = Object.fromEntries(
    handlers.filter(item => item.dynamic).map(item => [item.selector, item.handler])
  );

  initDynamicObserver(dynamicHandlers);
}
/**
 * sticky buy scroll
 */
let bodyPaddingCache = null;
let iostickyBuy = null;
function stickyBuyScroll(){
  const stickyBuy = document.querySelector('.sticky-buy');
  const buyBtn = document.querySelector('.buy-btn');
  if (!stickyBuy || !buyBtn) return;

  if (!iostickyBuy) {
    if (bodyPaddingCache === null) {
      bodyPaddingCache = parseFloat(getComputedStyle(document.body).getPropertyValue('--theme-body-padding'));
    }

    iostickyBuy = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isIntersecting = entry.boundingClientRect.bottom < bodyPaddingCache;
        stickyBuy.classList.toggle('visible', isIntersecting);
      });
    }, {
      rootMargin: `-${bodyPaddingCache}px 0px 0px 0px`,
      threshold: 0
    });

    iostickyBuy.observe(buyBtn);
  }
}
/**
 * announcementBar header and srcoll
 */
function headerGroupScroll(){
  const scrollTop = window.scrollY;
  const headerHei = header?.offsetHeight;
  const announcementHei = announcementBar ? announcementBar.offsetHeight : 0;
  const bannerHeight = banner ? banner.offsetHeight : 0;
  const bannerTop = banner ? banner.offsetTop : 0;

  if (announcementPos === null && announcementBar) {
    announcementPos = getComputedStyle(announcementBar).position;
  }
  if (headerPos === null && header) {
    headerPos = getComputedStyle(header).position;
  }

  let bodyPadding = 0;
  let innerPadding = 0;
  let headerMargin = 0;
  let headerTop = 0;

  if (announcementBar && !announcementBar.classList.contains('d-none')) {
    if (announcementPos === 'fixed') {
      bodyPadding = announcementHei;
      if (headerPos === 'static') {
        headerMargin = announcementHei;
      } else {
        headerTop = announcementHei;
      }
      if (!banner) {
        innerPadding = headerPos === 'sticky' ? announcementHei : announcementHei + headerHei;
      }
    } else {
      if (headerPos === 'fixed') {
        headerTop = Math.max(0, announcementHei - scrollTop);
        if (banner && bannerHeight === 0) {
          innerPadding = headerHei;
        }
      }
    }
  }

  if (header) {
    if (headerPos === 'fixed' || headerPos === 'sticky') {
      bodyPadding += headerHei;
      if (headerNav && headerNav.dataset.transparent && banner) {
        const headerHalf = headerHei;
        const banBottom = bannerTop + bannerHeight - headerHalf;
        
        const shouldRemoveTransparent = 
          scrollTop >= banBottom || 
          (headerPos === 'sticky' && scrollTop <= bannerTop - headerHalf) || 
          headerOver;
        
        if (shouldRemoveTransparent) {
          header.classList.remove('header-transparent');
        } else {
          header.classList.add('header-transparent');
        }
      }
    }
  }

  requestAnimationFrame(() => {
    if (header) {
      header.style.marginTop = `${headerMargin}px`;
      header.style.top = `${headerTop}px`;
    }
    document.body.style.setProperty('--theme-body-padding', `${bodyPadding}px`);
    document.body.style.paddingTop = `${innerPadding}px`;
  });
}

const mainBody        = document.getElementById('content');
const firstSection    = mainBody?.querySelector('div:first-child');
const banner          = firstSection?.querySelector('.banner');
const announcementBar = document.querySelector('.section-announcementbar');
const header          = document.querySelector('.section-header');
const headerNav       = header?.querySelector('nav.navbar');
const cartSidebar     = document.querySelector('.cart-sidebar');
const stickyBtn       = document.querySelector('.sticky-atcbtn');
const backToTop       = document.querySelector('.back-to-top');
let announcementPos   = null;
let headerPos         = null;
let headerOver        = false;

const debounceCartNoteChange = window.debounce(cartNoteChange);
const throttleHeaderGroupScroll = window.throttle(headerGroupScroll);
const throttleStickyBuyScroll = window.throttle(stickyBuyScroll);

if (announcementBar && sessionStorage.getItem('announcementclosed')) {
  announcementBar.classList.add('d-none');
}

if(cartSidebar){
  const cartSidebarNote = cartSidebar.querySelector('.cart-sidebar-note');
  const termsAgreement = cartSidebar.querySelector('.terms-agreement');

  if(cartSidebarNote){
    function handleNoteChange(e) {
      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note: e.target.value })
      })
      .then(response => response.json())
      .catch(error => {
        console.error('Error updating cart note:', error);
      });
    }
    const debouncedNoteChange = debounce(handleNoteChange,500);
    cartSidebar.addEventListener('input', (e) => {
      if (e.target.matches('[name="note"]') && cartSidebarNote.contains(e.target)) {
        debouncedNoteChange(e);
      }
    });
  }
}

let eventsInitialized = false;
function initDelegatedEvents(){
  if (eventsInitialized) return;
  eventsInitialized = true;

  initEventDelegation({
    click: [
      {
        selector: ".nice-select",
        handler: (e) => {
          const niceSelect = e.target.closest(".nice-select");
          const dropdown = niceSelect.querySelector(".nice-select-dropdown");
          const rect = niceSelect.getBoundingClientRect();
          const spaceBelow = window.innerHeight - rect.bottom;
          const spaceRight = window.innerWidth - rect.right;
          dropdown.classList.remove('dir-up','dir-down','dir-left','dir-right');
          if (spaceBelow < dropdown.offsetHeight && rect.top >= dropdown.offsetHeight) {
            dropdown.classList.add('dir-up');
          } else {
            dropdown.classList.add('dir-down');
          }
          if (spaceRight < dropdown.offsetWidth && rect.left >= dropdown.offsetWidth) {
            dropdown.classList.add('dir-right');
          } else {
            dropdown.classList.add('dir-left');
          }
        },
      },
      {
        selector:'.section-announcementbar .btnclose',
        handler: (e) => {
          e.preventDefault();
          if(announcementBar){
            announcementBar.classList.add('d-none');
            sessionStorage.setItem('announcementclosed',true);
            headerGroupScroll();
          }
        }
      },
      {
        selector:'[data-bs-toggle="modal"]',
        handler: (e) => {
          const element = e.target.closest('[data-bs-toggle="modal"]');
          if(element){
            e.preventDefault();

            const modalId = element?.dataset?.bsTarget;
            if(modalId){
              const modal = document.querySelector(modalId);
              if (modal) {
                SimpleModal.show(modal);
              }
            }
          }
        }
      },
      {
        selector:'[data-bs-toggle="offcanvas"]',
        handler: (e) => {
          const element = e.target.closest('[data-bs-toggle="offcanvas"]');
          if(element){
            e.preventDefault();

            const offcanvasId = element?.dataset?.bsTarget;
            if(offcanvasId){
              const offcanvas = document.querySelector(offcanvasId);
              if(offcanvas){
                SimpleOffcanvas.toggle(offcanvas);
              }
            }
          }
        }
      },
      {
        selector:'.cart-link',
        handler: (e) => {
          if(cartSidebar){
            e.preventDefault();
            SimpleOffcanvas.show(cartSidebar);
          }
        }
      },
      {
        selector:'.checkout-button',
        handler: (e) => {
          const checkoutButton = e.target.closest('.checkout-button');
          if(checkoutButton){
            const cartCheckout = checkoutButton.closest('.cart-checkout');
            if(cartCheckout){
              const checkBox = cartCheckout.querySelector('.terms-agreement [type="checkbox"]');
              if (checkBox && !checkBox.checked) {
                e.preventDefault();
                if(driver){
                  showPopover(checkBox);
                }else{
                  alert(checkBox.title);
                }
              }else{
                checkoutButton.classList.add('disabled');
                checkoutButton.innerHTML = '<span class="spinner-border"></span>';
              }
            }
          }
        }
      },
      {
        selector:'.card-product .card-variant .variant-label',
        handler:handleCardVariant
      },
      {
        selector:'.card-product .quickbuy-toggle',
        handler:handleQuickbuyToggle
      },
      {
        selector:'.back-to-top',
        handler: (e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    ],
    change:[
      {
        selector:'[data-translate="translatejs"]',
        handler: (e) => {
          if (typeof window.translate !== 'undefined'){
            translate.changeLanguage(e.target.value);
          }
        }
      },
      {
        selector:'select[name="country_code"]',
        handler: (e) => {
          e.target.closest('form').submit();
        }
      },
      {
        selector:'[data-translate="googletranslate"]',
        handler: (e) => {
          const element = e.target.closest('[data-translate="googletranslate"]');
          if(!gTransInited){
            alert(element.dataset.waitText);
            return;
          }
          const googleSelect = document.querySelector('.goog-te-combo');
          if(googleSelect){
            googleSelect.value = element.value;
            googleSelect.dispatchEvent(new Event('change', {
              bubbles: true,
              cancelable: true
            }));
          }
        }
      }
    ],
    focus:[
      {
        selector:'.form-search .searchbox',
        handler: (e) => {

        }
      }
    ],
    input:[
      {
        selector:'.cart-sidebar-note-input',
        handlers:debounceCartNoteChange
      }
    ]
  });

  const headerEl = document.querySelector('.section-header');
  if(headerEl){
    headerEl.addEventListener('mouseenter', (e) => {
      headerOver = true;
      headerGroupScroll();
    });
    headerEl.addEventListener('mouseleave', (e) => {
      headerOver = false;
      headerGroupScroll();
    });
  }

  document.querySelectorAll('[data-popover="driver"]').forEach(el => {
    el.addEventListener('mouseenter', (e) => {
      const target = e.target;
      if (target.title && typeof target.title === 'string' && target.title.trim().length > 0) {
        showTooltip(target);
      }
    });
    el.addEventListener('mouseleave', (e) => {
      const target = e.target;
      if (target.title && typeof target.title === 'string' && target.title.trim().length > 0) {
        if (driver) driver.destroy();
      }
    });
  });
}

let resizeInitialized = false;
function initResizeEvents() {
  if (resizeInitialized) return;
  resizeInitialized = true;
  headerGroupScroll();
  window.addEventListener('resize', throttleHeaderGroupScroll, { passive: true });
}

let scrollInitialized = false;
function initScrollEvents() {
  if (scrollInitialized) return;
  scrollInitialized = true;
  headerGroupScroll();
  window.addEventListener('scroll', throttleHeaderGroupScroll, { passive: true });
  window.addEventListener('scroll', throttleStickyBuyScroll, { passive: true });
}

window.addEventListener('resize', initResizeEvents, { once: true, passive: true });
window.addEventListener('scroll', initScrollEvents, { once: true, passive: true });
if (backToTop) {
  window.addEventListener('scroll', () => {
    backToTop.classList.toggle('ac', window.scrollY > 300);
  }, { passive: true });
}
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    headerGroupScroll();
    initLazyElements();
    initDelegatedEvents();
  }, { timeout: 2000 });
} else {
  setTimeout(() => {
    headerGroupScroll();
    initLazyElements();
    initDelegatedEvents();
  }, 1000);
}
